import classNames from "classnames";
import { Button } from "primereact/button";
import { ColorPicker } from "primereact/colorpicker";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import React, { useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { Api } from "../../../../services/api";
import { userInfo } from "../../../../services/authHandlers";
import { ButtonPagueDefault, ColorPickerPague } from "../../../../styles/primeReactConfig";
import Preview from "./preview";

function NovoTemaDialog(props) {

  const regexHex = /[^ABCDEFabcdef0-9]/
  const fileInput = useRef()
  const fileInput2 = useRef()
  const [corGradiente1, setCorGradiente1] = useState('');
  const [corGradiente2, setCorGradiente2] = useState('');
  const [corGradiente3, setCorGradiente3] = useState('');
  const [corCard1, setCorCard1] = useState('');
  const [corCard2, setCorCard2] = useState('');
  const [corFonte, setCorFonte] = useState('');
  const [corFonte2, setCorFonte2] = useState('');
  const [corGradienteBotao1, setCorGradienteBotao1] = useState('');
  const [corGradienteBotao2, setCorGradienteBotao2] = useState('');
  const [corBotaoHover1, setCorBotaoHover1] = useState('');
  const [corBotaoHover2, setCorBotaoHover2] = useState('');
  const [textoBotaoCor, setTextoBotaoCor] = useState('ffffff')
  const [corBotaoSombra, setCorBotaoSombra] = useState('');
  const [showLogo, setShowLogo] = useState(true)
  const [showFooter, setShowFooter] = useState(true)
  const [logoDiretoClaro, setLogoDiretoClaro] = useState(true);
  const [corTabelaTitulo, setCorTabelaTitulo] = useState('');
  const [corTabelaConteudo, setCorTabelaConteudo] = useState('');
  const [frontUpload, setFrontUpload] = useState('');
  const [logoUpload, setLogoUpload] = useState('');
  const [frontURL, setFrontURL] = useState('');
  const [logoURL, setLogoURL] = useState('');
  const [descricao, setDescricao] = useState('');
  const [onlyOneItemRule1, setOnlyOneItemRule1] = useState(false);
  const [onlyOneItemRule2, setOnlyOneItemRule2] = useState(false);
  const [tituloPagina, setTituloPagina] = useState();
  const [loading, setLoading] = useState(false);

  const addNewLayout = async (event) => {
    event.preventDefault()
    if (frontUpload !== undefined && logoUpload !== undefined) {
      const formData = new FormData();

      formData.append('front_img', frontUpload, frontUpload.name);
      formData.append('logo_img', logoUpload, logoUpload.name);
      formData.append('mostrar_logo', showLogo);
      formData.append('mostrar_footer', showFooter);
      formData.append('logo_direto_claro', logoDiretoClaro);
      formData.append('cor_gradiente1', corGradiente1.trim());
      formData.append('cor_gradiente2', corGradiente2.trim());
      formData.append('cor_gradiente3', corGradiente3.trim());
      formData.append('sombra_botao_cor1', corBotaoSombra.trim());
      formData.append('texto_botao_cor', textoBotaoCor.trim())
      formData.append('gradiente_botao_cor1', corGradienteBotao1.trim());
      formData.append('gradiente_botao_cor2', corGradienteBotao2.trim());
      formData.append('hover_botao_cor1', corBotaoHover1.trim());
      formData.append('hover_botao_cor2', corBotaoHover2.trim());
      formData.append('cor_card1', corCard1.trim());
      formData.append('cor_card2', corCard2.trim());
      formData.append('cor_fonte', corFonte.trim());
      formData.append('cor_fonte_2', corFonte2.trim());
      formData.append('descricao', descricao);
      formData.append('customizacao_url_credor', props.providerURL);
      formData.append('titulo_pagina', tituloPagina);
      formData.append('cor_tabela_titulo', corTabelaTitulo);
      formData.append('cor_tabela_conteudo', corTabelaConteudo);
      const config = { headers: { Authorization: `Bearer ${userInfo.usuario_id}`, 'Content-Type': 'multipart/form-data' } }
      try {
        setLoading(true)
        await Api.post("customizacaoCredor/insere", formData, config);
        props.reload()
        toast.success('Layout adicionado com sucesso!');
        //console.log(data);
      } catch (error) {
        console.log(error);
        toast.error('Erro ao criar novo tema!')
      } finally {
        setLoading(false)
      }
    } else {
      toast.error('Por favor insira as imagens requisitadas')
    }
  }

  function itemTemplate(file, props) {
    return (
      <div className="flex justify-content-center flex-wrap surface-200">
        <div className="block ">
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={'100%'}
            className={classNames({ 'hidden': !file.objectURL })}
          />
          <div className="flex text-center ml-3">
            {file.name}
            <Tag
              value={props.formatSize} severity="info" className="p-px-3 ml-6 p-py-2" />
          </div>
        </div>
      </div>
    )
  }

  const handleImageUploadFront = async Data => {
    const file = Data.files[0];
    //console.log(file)
    setFrontUpload(file)
    setFrontURL(file.objectURL)
    if (file.size < 2000000) {
      //   const base64Front = await imageToBase64(file.objectURL);
      //   const buffer = new ArrayBuffer(base64Front.length);
      //   const view = new Uint8Array(buffer);
      //   const blob = new Blob([view],{type:file.type})
      //   console.log(blob)
    } else {
      fileInput.current.clear()
      toast.error('O tamanho máximo permitido é de 2Mb')
    }

  };

  const handleImageUploadLogo = async Data => {
    const file = Data.files[0];

    setLogoUpload(file)
    setLogoURL(file.objectURL)
    if (file.size < 2000000) {
      //   const base64Logo = await imageToBase64(file.objectURL);
      //   const buffer = new ArrayBuffer(base64Logo.length);
      //   const view = new Uint8Array(buffer);
      //   const blob = new Blob([view],{type:file.type})

    } else {
      fileInput2.current.clear()
      toast.error('O tamanho máximo permitido é de 2Mb')
    }

  }

  return (
    <Dialog
      visible
      onHide={() => props.close()}
      pt={{
        root: 'w-screen md:w-[70vw] max-h-[80vh] ',
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
      header="Adicionar novo tema"
    >
      <form onSubmit={(e) => addNewLayout(e)}>
        <div className='w-full grid gap-4'>
          <div className='grid md:flex gap-4 px-2'>
            <div className='w-1/2 '>
              <p>Imagem Capa</p>
              <FileUpload
                ref={fileInput}
                name="demo"
                chooseLabel="Escolher"
                chooseOptions={{
                  style: {
                    cursor: !onlyOneItemRule1 && 'pointer',
                    backgroundColor: onlyOneItemRule1 && 'gray',
                    pointerEvents: onlyOneItemRule1 && 'none'
                  }
                }}
                url={frontURL}
                onClear={() => setOnlyOneItemRule1(false)}
                onSelect={(e) => { setOnlyOneItemRule1(true); handleImageUploadFront(e) }}
                onValidationFail={() => setOnlyOneItemRule1(false)}
                onProgress={() => setOnlyOneItemRule1(false)}
                uploadLabel="Enviar"
                uploadOptions={{ style: { display: 'none' } }}
                cancelLabel="Limpar"
                cancelOptions={{ className: 'outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-300', icon: "pi pi-trash" }}
                customUpload
                //headerTemplate={headerTemplate1}
                // maxFileSize={1000000}
                // invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido"
                // invalidFileSizeMessageDetail="o limite de upload e de {0}"
                itemTemplate={itemTemplate}
                uploadHandler={handleImageUploadFront}
                accept="image/*"
                emptyTemplate={
                  <>
                    {/* <img src={frontURL} alt="" style={{width:'100%'}} /> */}
                    {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                    <p className="p-m-0">
                      *Envie uma imagem com tamanho maximo de 2Mb.</p>
                  </>
                }
              />
            </div>
            <div className='w-1/2 '>
              <p>Imagem Logo</p>
              <FileUpload
                ref={fileInput2}
                name="demo[]"
                url={logoURL}
                chooseLabel="Escolher"
                chooseOptions={{
                  style: {
                    cursor: !onlyOneItemRule2 && 'pointer',
                    backgroundColor: onlyOneItemRule2 && 'gray',
                    pointerEvents: onlyOneItemRule2 && 'none'
                  }
                }}
                onClear={() => setOnlyOneItemRule2(false)}
                onSelect={(e) => { setOnlyOneItemRule2(true); handleImageUploadLogo(e) }}
                onProgress={() => setOnlyOneItemRule2(false)}
                uploadLabel="Enviar"
                uploadOptions={{ style: { display: 'none' } }}
                cancelLabel="Limpar"
                cancelOptions={{
                  className: 'outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-300',
                  icon: <FaTrash />
                }}
                customUpload
                //headerTemplate={headerTemplate2}
                itemTemplate={itemTemplate}
                uploadHandler={handleImageUploadLogo}
                accept="image/*"
                emptyTemplate={
                  <>
                    {/* <img src={logoURL} alt="" style={{width:'100%'}} /> */}
                    {/* <i className="pi pi-file text-black-alpha-60 text-8xl p-4 border-700 border-circle border-2 " /> */}
                    <p className="p-m-0">
                      *Envie uma imagem com tamanho máximo de 2Mb.</p>
                  </>
                }
              />
            </div>
          </div>
          <div className='flex'>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Gradiente 1</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corGradiente1}
                onChange={(e) => setCorGradiente1(e.value)}
              />
              <InputText
                className='mt-2'
                value={corGradiente1}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorGradiente1(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Gradiente 2</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corGradiente2}
                onChange={(e) => setCorGradiente2(e.value)}
              />
              <InputText
                className='mt-2'
                value={corGradiente2}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorGradiente2(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Gradiente 3</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corGradiente3}
                onChange={(e) => setCorGradiente3(e.value)}
              />
              <InputText
                className='mt-2'
                value={corGradiente3}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorGradiente3(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className="flex">
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Fonte 1</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corFonte}
                onChange={(e) => setCorFonte(e.value)}
              />
              <InputText
                className='mt-2'
                value={corFonte}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorFonte(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Fonte 2</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corFonte2}
                onChange={(e) => setCorFonte2(e.value)}
              />
              <InputText
                className='mt-2'
                value={corFonte2}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorFonte2(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className='flex'>
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Card 1</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corCard1}
                onChange={(e) => setCorCard1(e.value)}
              />
              <InputText
                className='mt-2'
                value={corCard1}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorCard1(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Card 2</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corCard2}
                onChange={(e) => setCorCard2(e.value)}
              />
              <InputText
                className='mt-2'
                value={corCard2}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorCard2(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className='flex'>
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Tabela Título</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corTabelaTitulo}
                onChange={(e) => setCorTabelaTitulo(e.value)}
              />
              <InputText
                className='mt-2'
                value={corTabelaTitulo}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorTabelaTitulo(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/2 grid gap-1 px-2'>
              <p>Cor Tabela Conteúdo</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corTabelaConteudo}
                onChange={(e) => setCorTabelaConteudo(e.value)}
              />
              <InputText
                className='mt-2'
                value={corTabelaConteudo}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorTabelaConteudo(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className='flex'>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Gradiente 1</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corGradienteBotao1}
                onChange={(e) => setCorGradienteBotao1(e.value)}
              />
              <InputText
                className='mt-2'
                value={corGradienteBotao1}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorGradienteBotao1(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Gradiente 2</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corGradienteBotao2}
                onChange={(e) => setCorGradienteBotao2(e.value)}
              />
              <InputText
                className='mt-2'
                value={corGradienteBotao2}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorGradienteBotao2(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Sombra</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corBotaoSombra}
                onChange={(e) => setCorBotaoSombra(e.value)}
              />
              <InputText
                className='mt-2'
                value={corBotaoSombra}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorBotaoSombra(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className='flex'>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Hover 1</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corBotaoHover1}
                onChange={(e) => setCorBotaoHover1(e.value)}
              />
              <InputText
                className='mt-2'
                value={corBotaoHover1}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorBotaoHover1(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Hover 2</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={corBotaoHover2}
                onChange={(e) => setCorBotaoHover2(e.value)}
              />
              <InputText
                className='mt-2'
                value={corBotaoHover2}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setCorBotaoHover2(e.target.value.replace(regexHex, ''))}
              />
            </div>
            <div className='w-1/3 grid gap-1 px-2'>
              <p>Cor Botao Fonte</p>
              <ColorPicker
                pt={ColorPickerPague}
                value={textoBotaoCor}
                onChange={(e) => setTextoBotaoCor(e.value)}
              />
              <InputText
                className='mt-2'
                value={textoBotaoCor}
                maxLength="6"
                placeholder="*Cor em hexadecimal"
                required
                onChange={(e) => setTextoBotaoCor(e.target.value.replace(regexHex, ''))}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-1/3 flex mt-2">
              <InputSwitch checked={showLogo} onChange={(e) => setShowLogo(e.value)} />
              <div className="mt-2">
                <label className=" ml-2">Mostrar Logo</label>
              </div>
            </div>
            <div className="w-1/3 flex mt-2">
              <InputSwitch checked={showFooter} onChange={(e) => setShowFooter(e.value)} />
              <div className="mt-2">
                <label className=" ml-2">Mostrar Rodapé</label>
              </div>
            </div>
            <div className="w-1/3 flex mt-2">
              <InputSwitch checked={logoDiretoClaro} onChange={(e) => setLogoDiretoClaro(e.value)} />
              <div className="mt-2">
                <label className=" ml-2">Logo Branco</label>
              </div>
            </div>
          </div>
          <Preview config={{
            corGradiente1,
            corGradiente2,
            corGradiente3,
            corCard1,
            corCard2,
            corFonte,
            corFonte2,
            corGradienteBotao1,
            corGradienteBotao2,
            corBotaoHover1,
            corBotaoHover2,
            textoBotaoCor,
            corBotaoSombra,
            logoURL,
            frontURL,
            showLogo,
            showFooter,
            corTabelaTitulo,
            corTabelaConteudo,
            logoDiretoClaro,
          }}
          />
          <div className="flex w-full">
            <div className='p-2 w-1/2 grid gap-2'>
              <h6>Descrição do Tema</h6>
              <InputText
                value={descricao}
                required
                onChange={(e) => setDescricao(e.target.value)}
              />
            </div>
            <div className='p-2 w-1/2 grid gap-2'>
              <h6>Título da página</h6>
              <InputText
                value={tituloPagina}
                required
                onChange={(e) => setTituloPagina(e.target.value)}
              />
            </div>
          </div>
          <div className="w-full flex justify-center mt-5">
            <div className="grid w-full md:w-5/12 ">
              <Button
                pt={ButtonPagueDefault}
                loading={loading}
                label="Adicionar"
                type="submit"
              ></Button>
            </div>
          </div>
        </div>
      </form>
    </Dialog>
  )
}

export default NovoTemaDialog